import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useCallback, useEffect, useState } from 'react';
import { DropDown, SimpleModal, SimpleModalBody, SimpleModalHeader, SolidButton } from '@noths/polaris-client-ribbons-design-system';
import { pxToRem } from '@noths/polaris-client-styles';
import * as styles from "../styles/LocaleModal.styles";
import { countryOptions, currencyOptions } from "../utils";
import { decodeCountryValue, encodeCountryValue } from "../utils/dropdownOptions";
var simpleModalContentStyle = {
  maxWidth: pxToRem(360)
};
export var LocaleModal = function LocaleModal(_ref) {
  var isOpen = _ref.isOpen,
    locale = _ref.locale,
    onClose = _ref.onClose,
    onSave = _ref.onSave,
    useScopedStyles = _ref.useScopedStyles;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    country = _useState2[0],
    setCountry = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    currency = _useState4[0],
    setCurrency = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    hasFormSubmitted = _useState6[0],
    setFormSubmitted = _useState6[1];
  var hasCurrencyError = hasFormSubmitted && currency === '';
  var hasCountryError = hasFormSubmitted && country === '';
  var hasError = hasCountryError || hasCurrencyError;
  useEffect(function () {
    if (locale) {
      setCountry(encodeCountryValue(locale));
      setCurrency(locale.currency);
    } else {
      setCountry('');
      setCurrency('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale]);
  var onSubmit = useCallback(function (evt) {
    evt.preventDefault();
    setFormSubmitted(true);
    if (!hasError) {
      var _locale = _objectSpread({
        currency
      }, decodeCountryValue(country));
      onSave(_locale);
    }
  }, [country, currency, hasError, onSave]);
  var onCountryChange = useCallback(function (evt) {
    return setCountry(evt.currentTarget.value);
  }, []);
  var onCurrencyChange = useCallback(function (evt) {
    return setCurrency(evt.currentTarget.value);
  }, []);
  return /*#__PURE__*/React.createElement(SimpleModal, {
    contentLabel: "Select Locale",
    contentStyles: simpleModalContentStyle,
    isOpen: isOpen,
    onRequestClose: onClose,
    useScopedStyles: useScopedStyles
  }, /*#__PURE__*/React.createElement(SimpleModalHeader, {
    onClose: onClose,
    title: "Shopping preferences"
  }), /*#__PURE__*/React.createElement(SimpleModalBody, null, /*#__PURE__*/React.createElement("form", {
    "data-testid": "update-locale-form",
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(_StyledDropDown, {
    error: hasCountryError ? 'Please select a country' : null,
    id: "country",
    label: "Country",
    onChange: onCountryChange,
    options: countryOptions,
    value: country,
    $_css: styles.dropDown
  }), /*#__PURE__*/React.createElement(_StyledDropDown2, {
    error: hasCurrencyError ? 'Please select a currency' : null,
    id: "currency",
    label: "Currency",
    onChange: onCurrencyChange,
    options: currencyOptions,
    value: currency,
    $_css2: styles.dropDown
  }), /*#__PURE__*/React.createElement(SolidButton, {
    fullWidth: true
  }, "Save preferences"))));
};
var _StyledDropDown = _styled(DropDown)(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledDropDown2 = /*#__PURE__*/_styled2(DropDown).withConfig({
  displayName: "LocaleModal___StyledDropDown2",
  componentId: "sc-1uw5s5c-0"
})(["", ""], function (p) {
  return p.$_css2;
});